@if(this.faq.length > 0){
    <div id="faq_list_content">

        <demooz-card id="card_search" [withMargin]="false">
            <div>{{'COMMUNITY.SEARCH' | translate}}</div>
            <form [formGroup]="this.searchForm">
                <demooz-input type="text" icon="search-outline" formName="search" [showBtnClearInput]="true" />
            </form>
        </demooz-card>

        @if(this.faqToDisplay.length > 0){
            <div id="faq_list">
                @for(faq of this.faqToDisplay; track $index){
                    @if(!this.maxItemsFaq || (this.showAllFaq || $index < this.maxItemsFaq)){
                        <demooz-card 
                            class="faq" 
                            [fullHeight]="true" 
                            [withMargin]="false" 
                            (click)="this.openModalFaq(faq)"
                            >
                            <div class="faq_content">
                                @if(faq.mediaThumbnail && faq.mediaThumbnail != ''){
                                    <img [src]="faq.mediaThumbnail" />
                                }
                                <div class="faq_title">{{faq.title}}</div>        
                            </div>
                        </demooz-card>
                    }
                }

                @if(this.maxItemsFaq && !this.showAllFaq && this.faqToDisplay.length > this.maxItemsFaq){
                    <div id="faq_list_btn_show_all" (click)="this.displayAllFaq()">
                        <div>{{'COMMUNITY.SHOW_MORE_RESPONSE' | translate}}</div>
                        <ion-icon name="caret-down-outline"></ion-icon>
                    </div>
                }

            </div>
        }
        @else{
            <demooz-message type="info">{{'COMMUNITY.MSG_NO_FAQ' | translate}}</demooz-message>
        }

    </div>
}

<demooz-modal #modalFaq [heightAuto]="false" (onDidDismiss)="this.onDidDismissModalFaq($event)">
    @if(this.faqSelected){
        <app-faq-details [faq]="this.faqSelected"/>
    }
</demooz-modal>